export default "__VITE_ASSET__DDusmtyF__"